'use client';

import cn from 'classnames';
import { ComponentRef, forwardRef } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { TabsRootProps } from '../model/tabs.types';
import styles from './tabs.module.scss';


export const Tabs = forwardRef<
    ComponentRef<typeof TabsPrimitive.Root>,
    TabsRootProps
>(function Tabs ({
    className,
    tabsPosition = 'top',
    ...props
}, ref) {
    return (
        <TabsPrimitive.Root
            ref={ ref }
            data-tabs-position={ tabsPosition }
            className={ cn(styles.root, className) }
            { ...props }
        />
    );
});
